"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@osmosys/utils");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const parser_html_1 = tslib_1.__importDefault(require("prettier/parser-html"));
const standalone_1 = tslib_1.__importDefault(require("prettier/standalone"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_monaco_editor_1 = tslib_1.__importDefault(require("react-monaco-editor"));
class CodeEditor extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.onResize = this.onResize.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onEditorWillMount = this.onEditorWillMount.bind(this);
        this.onEditorMount = this.onEditorMount.bind(this);
        this.onHtml = this.onHtml.bind(this);
        this.onJson = this.onJson.bind(this);
    }
    componentDidMount() {
        utils_1.logger.debug('CodeEditor.componentDidMount');
        window.addEventListener('resize', this.onResize);
    }
    componentWillUnmount() {
        utils_1.logger.debug('CodeEditor.componentWillUnmount');
        window.removeEventListener('resize', this.onResize);
        if (this.timeout1) {
            clearTimeout(this.timeout1);
        }
    }
    onResize() {
        utils_1.logger.debug('CodeEditor.onResize');
        if (!this.editor) {
            console.warn('No this.editor', this);
            return;
        }
        this.editor.layout();
    }
    format() {
        this.props.onChange(standalone_1.default.format(this.props.value, {
            parser: 'html',
            plugins: [parser_html_1.default],
        }));
    }
    onChange(html) {
        utils_1.logger.debug('CodeEditor.onChange');
        this.props.onChange(html);
    }
    onEditorMount(editor, monaco) {
        utils_1.logger.debug('CodeEditor.onEditorMount');
        if (this.props.focusOnMount) {
            editor.focus();
        }
        this.editor = editor;
        this.monaco = monaco;
        if ((this.props.language || 'html') === 'html') {
            if (this.monaco.languages.html) {
                this.onHtml();
            }
            else {
                monaco.languages.onLanguage('html', this.onHtml);
            }
        }
        else if (this.props.language === 'json') {
            if (this.monaco.languages.json) {
                this.onJson();
            }
            else {
                monaco.languages.onLanguage('json', this.onJson);
            }
        }
        this.onResize();
        this.timeout1 = setTimeout(() => {
            this.onResize();
            // setTimeout(() => {
            //   this.onResize();
            // }, 1 * 1000);
        }, 100);
    }
    onEditorWillMount(monaco) {
        utils_1.logger.debug({ monaco }, 'CodeEditor.onEditorWillMount');
    }
    onJson() {
        utils_1.logger.debug('CodeEditor.onJson');
    }
    onHtml() {
        utils_1.logger.debug('CodeEditor.onHtml');
        // Configure HTML format options
        this.monaco.languages.html.htmlDefaults.setOptions({
            format: {
                contentUnformatted: '',
                endWithNewline: true,
                extraLiners: '',
                indentHandlebars: true,
                indentInnerHtml: true,
                insertSpaces: true,
                maxPreserveNewLines: 80,
                preserveNewLines: true,
                tabSize: 1,
                unformatted: '',
                wrapAttributes: 'force-expand-multiline',
                wrapLineLength: 120,
            },
            suggest: {
                snippetsPreventQuickSuggestions: false,
            },
        });
        if (this.props.suggestions) {
            utils_1.logger.warn('CodeEditor | this.props.suggestions: not yet implemented');
            // const suggestions = Object.entries(OSYS_ATTRS)
            //   .filter(([key, tag]) => !tag.startsWith('_'))
            //   .map(([key, tag]) => {
            //     return {
            //       documentation: `use \`${tag}\` to instruct Osmosys to recognize the ${key.replace(
            //         /:/gm,
            //         ' '
            //       )}`,
            //       insertText: `${tag}=""`,
            //       kind: this.monaco.languages.CompletionItemKind.Property,
            //       label: tag,
            //     };
            //   });
            // Register completions
            // this.monaco.languages.registerCompletionItemProvider('html', {
            //   provideCompletionItems(model, position) {
            //     return {
            //       suggestions,
            //     };
            //   },
            // });
        }
    }
    render() {
        utils_1.logger.debug('CodeEditor.render');
        const { left, right, bottom, top, dark, light, maxHeight = 400, readOnly, lineNumbers, addWrapper, } = this.props;
        const toolbarClasses = {
            'bg-dark': dark || !light,
            'bg-white': light || !dark,
        };
        const child = (react_1.default.createElement("div", { className: classnames_1.default({
                'd-flex flex-grow-1': this.props.flex,
                'h-100 w-100': !this.props.flex,
            }, 'CodeEditor d-flex flex-column') },
            top && (react_1.default.createElement("div", { className: classnames_1.default('CodeEditor-top-toolbar d-flex p-0 border-bottom', toolbarClasses) }, top)),
            react_1.default.createElement("div", { className: classnames_1.default('CodeEditor-inner-container d-flex flex-grow-1') },
                left && (react_1.default.createElement("div", { className: classnames_1.default('CodeEditor-sidebar-left') }, left)),
                react_1.default.createElement(react_monaco_editor_1.default, { language: this.props.language || 'html', theme: dark ? 'vs-dark' : 'vs', value: this.props.value, onChange: this.onChange, options: {
                        acceptSuggestionOnEnter: true,
                        lineNumbers,
                        quickSuggestions: true,
                        readOnly,
                    }, editorWillMount: this.onEditorWillMount, editorDidMount: this.onEditorMount }),
                right && (react_1.default.createElement("div", { className: classnames_1.default('CodeEditor-sidebar-right') }, right))),
            bottom && (react_1.default.createElement("div", { className: classnames_1.default('CodeEditor-bottom-toolbar p-0 border-top', toolbarClasses) }, bottom))));
        if (addWrapper) {
            return (react_1.default.createElement("div", { className: "w-100 d-flex border overflow-hidden rounded-lg", style: { height: maxHeight } }, child));
        }
        return child;
    }
}
exports.CodeEditor = CodeEditor;
CodeEditor.defaultProps = {
    focusOnMount: true,
    language: 'html',
};
//# sourceMappingURL=index.js.map